export default {
  current: 'en',
  lang: {},
  userLocale: null
}
